<template>
    <div
        class="list-client__container"
        v-if="isEnabled"
    >
        <div style="display: flex" v-if="selectedClientOrderId === null">
            <filter-control-datepicker
                    v-if="Object.keys(filterDataDate).length !== 0"
                    :items="filterDataDate"
                    :selectedItems="selectedFilterDate"
                    :width="'220px'"
                    :height="'44px'"
                    @onChange="onChangeFilter($event, 'date')"
            />
            <dropdown
                    v-if="Object.keys(filterDataClients).length"
                    title="Клиенты"
                    :items="filterDataClients"
                    :selectedItems="selectedFilterClients"
                    :isManyItems="true"
                    :isSearch="true"
                    :width="'220px'"
                    :height="'44px'"
                    @onChange="onChangeFilter($event, 'clients')"
            />
        </div>
        <button
                v-else
                class="button-back"
                @click="selectedClientOrderId = null"
        >
            Назад
        </button>
        <table-settings
                :labels="labels"
                :rows="rows"
                :isPreloader="isPreloader()"
                :columnSettings="columnSettings"
                @clickTableCell="onClickOrder"
                @removeRow="onRemoveRow"
                @sendRow="onSendRow"
        />
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import serviceAuth from "../../services/serviceAuth";
import TableSettings from "../../components/Tables/TableSettings";
import ServiceRagic from "../../services/ServiceRagic";
import FilterControlDatepicker from "../../components/Filter/FilterControls/FilterControlDatepicker";
import Dropdown from "../../components/Base/Dropdown";
import UtilDate from "../../utils/UtilDate";
export default {
    name: 'ViewSettingsRagicBudget',
    components: {
        FilterControlDatepicker,
        TableSettings,
        Dropdown
    },
    /**
     * Данные компонента
     * @property {boolean} isGettingList флаг получения списка клиентов
     * @property {boolean} isEnabled флаг разрешения
     */
    data: () => ({
        filterDataDate: {},
        filterDataClients: {},
        selectedFilterDate: [],
        selectedFilterClients: [],
        rows: [],
        isGettingList: false,
        isEnabled: false,
        columnSettings: {},
        labels: {},
        selectedClientOrderId: null,
        labelsDetail: {},
        rowsDetail: []
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {string} activeProjectId - id активного проекта
         */
        ...mapState({
            activeProjectId: state => state.activeProjectId
        }),
    },
    watch: {
        selectedFilterDate(){
            this.getFiltersClients();
            this.getTable();
        },
        selectedFilterClients(){
            this.getTable();
        },
        selectedClientOrderId(){
            if(this.selectedClientOrderId !== null){
                this.getTableDetail();
            }else{
                this.getTable();
            }
        }
    },
    mounted() {
        // устанавливаем текущее название страницы
        this.setCurrentViewName("Бюджеты Ragic");
        // получаем право на редактирование
        this.isEnabled = serviceAuth.checkPermission(this.activeProjectId, 'global_view');
        if(this.isEnabled){
            this.getFiltersDates();
            this.getFiltersClients();
        }
    },
    methods: {
        /**
         * проксируем мутации из стора
         * @property {Function} setCurrentViewName - установить текущее имя страницы
         */
        ...mapMutations([
            'setCurrentViewName'
        ]),
        /**
         * запрос на списка менеджеров
         * @async
         */
        async getTable() {
            this.isGettingList = true;
            ServiceRagic.postTableClients(this.selectedFilterDate, this.selectedFilterClients, (data) => {
                let {fields, columnSettings, items} = data;
                this.labels = fields;
                this.rows = items;
                this.columnSettings = columnSettings;
                this.isGettingList = false;
            });
        },
        async getTableDetail() {
            this.isGettingList = true;
            ServiceRagic.postTableSuppliers(this.selectedClientOrderId, (data) => {
                let {fields, columnSettings, items} = data;
                this.labels = fields;
                this.rows = items;
                this.columnSettings = columnSettings;
                this.isGettingList = false;
            });
        },
        async getFiltersDates() {
            ServiceRagic.postFilterDates([], [], (data) => {
                this.filterDataDate = data;
                if(!this.selectedFilterDate.length && Object.keys(this.filterDataDate).length){
                    this.selectedFilterDate = UtilDate.getNearDate(Object.keys(this.filterDataDate))
                }
            });
        },
        async getFiltersClients() {
            ServiceRagic.postFilterClients(this.selectedFilterDate, [], (data) => {
                this.filterDataClients = data;
            });
        },
        isPreloader(){
            return this.isGettingList;
        },
        /**
         * изменить фильтр
         * @param {string} key - ключ в объекте
         * @param {array} data - данные
         */
        onChangeFilter(data, key) {
            switch (key) {
                case "date":{
                    this.selectedFilterDate = data;
                    break;
                }
                case "clients":{
                    this.selectedFilterClients = data;
                    break;
                }
            }
        },
        onClickOrder(row){
            this.selectedClientOrderId = row.id;
        },
        onRemoveRow(row){
            let isConfirm = confirm("Вы уверены что хотите удалить?");
            if(!isConfirm){
                return;
            }
            ServiceRagic.postRemoveOrder(row.id, () => {
                let bufferRows = [...this.rows];
                this.rows = [...bufferRows.filter(itemRow => itemRow.id !== row.id)];
            });
        },
        onSendRow(row){
            ServiceRagic.postSendOrder(row.id, () => {
                this.getTable();
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .list-client__container {
        margin-top: 10px;
        padding: 20px 25px;
        background: #fff;
        border-radius: 14px;
        -webkit-box-flex: 1;
    }
    .list-client__item{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
    }
    .list-client__item_pointer{
        cursor: pointer;
    }
    .list-client__item_active{
        background: #dcdcdc;
    }

    .pagination{
        margin: 10px 0;
        display: flex;
        &__item{
            padding: 5px;
            text-decoration: underline;
            cursor: pointer;
        }

        .active{
            text-decoration: none;
        }

    }

    .button-back{
        border-radius: 10px;
        border: none;
        background: none;
        color: #2686e6;
        outline: none;
        padding: 10px;
        cursor: pointer;
    }
</style>